import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/termometre.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Grid from '@material-ui/core/Grid';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import BlueButton from '../../../buttons/BlueButton';
import Termometre from './Termometre';

const pagination = 15;

function sortData(arr, search) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) => (a.txtlocal < b.txtlocal ? -1 : 1))
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) => info.txtlocal && info.txtlocal.toUpperCase().includes(s),
                    );
                    if (filter && filter.length > 0) {
                        arr.push(<Termometre key={randomstring()} termometre={info} />);
                    }
                } else {
                    arr.push(<Termometre key={randomstring()} termometre={info} />);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListTermometres extends React.Component {
    state = {
        index: 0,
        termometres: sortData(this.props.termometres, this.props.search),
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            index: 0,
            termometres: sortData(nextProps.termometres, nextProps.search),
        });
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    render() {
        const { index, termometres } = this.state;
        const { termometres_is_loading, termometres_has_errored } = this.props;
        const data = [...termometres].splice(0, index + pagination);
        const length = termometres.length;

        if (termometres_has_errored.hasErrored) {
            return (
                <Error open type={termometres_has_errored.hasErrored}  message={termometres_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {termometres_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {data.map((u) => {
                            return u;
                        })}
                        {length > index + pagination && (
                            <Grid
                                container
                                justify="center"
                                className={'flex_grow_1 align_center margin_top_24'}
                            >
                                <Grid item xs={10} sm={6} className="padding_bottom_12">
                                    <BlueButton id="next" onClick={this.handleClick} />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            );
        }
    }
}

ListTermometres.propTypes = {
    termometres: PropTypes.array.isRequired,
    termometres_is_loading: PropTypes.bool.isRequired,
    termometres_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        termometres: state.termometres,
        termometres_is_loading: state.termometres_is_loading,
        termometres_has_errored: state.termometres_has_errored,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ListTermometres));



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometres/List.js